export const getters = {
    list: state => state.list,
    archivedTasks: state => state.archivedTasks,
    deletedTasks: state => state.deletedTasks,
    inventory: state => state.inventory,
    model: state => state.model,
    rules: state => state.rules,
    columns: state => state.columns,
    filter: state => state.filter,
    pagination: state => state.pagination,
    sort: state => state.sort,  
    tasksForCalendar: state => state.tasksForCalendar,   
    taskCounts: state => state.taskCounts,  
     
  };
  